export default __webpack_public_path__ + "static/media/equipment_bg.0c2a6982.png";